function calculateRepeatDuration(duration, repeat, _repeatDelay) {
    return duration * (repeat + 1);
}

export { calculateRepeatDuration };
//# sourceMappingURL=calc-repeat-duration.mjs.map
